import { render, staticRenderFns } from "./RangeSlider.vue?vue&type=template&id=a43bafac&scoped=true&"
import script from "./RangeSlider.vue?vue&type=script&lang=ts&"
export * from "./RangeSlider.vue?vue&type=script&lang=ts&"
import style0 from "./RangeSlider.vue?vue&type=style&index=0&id=a43bafac&prod&lang=scss&scoped=true&"
import style1 from "./RangeSlider.vue?vue&type=style&index=1&id=a43bafac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43bafac",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TitleDescription: require('/var/www/components/TitleDescription.vue').default,RangeSliderItem: require('/var/www/components/RangeSliderItem.vue').default})
